import { Route } from 'react-router-dom'

import { WarehouseActivatePage } from '@/features/warehouse/ActivatePage'
import { WarehouseAttendancePage } from '@/features/warehouse/AttendancePage'
import { WarehouseDispatchEditorPage } from '@/features/warehouse/DispatchEditorPage'
import { WarehouseDispatchListPage } from '@/features/warehouse/DispatchListPage'
import { WarehouseEntryRedirect } from '@/features/warehouse/WarehouseEntryRedirect'
import { WarehouseHomePage } from '@/features/warehouse/HomePage'
import { WarehouseLoginPage } from '@/features/warehouse/LoginPage'
import { WarehouseStockPage } from '@/features/warehouse/StockPage'
import { AuthLayout } from '@/shared/layouts/AuthLayout'
import { WarehouseAppLayout } from '@/shared/layouts/WarehouseAppLayout'

export const warehouseRouteElements = (
  <Route path="/warehouse">
    <Route element={<AuthLayout />}>
      <Route index element={<WarehouseEntryRedirect />} />
      <Route path="activate" element={<WarehouseActivatePage />} />
      <Route path="login" element={<WarehouseLoginPage />} />
    </Route>
    <Route element={<WarehouseAppLayout />}>
      <Route path="home" element={<WarehouseHomePage />} />
      <Route path="attendance" element={<WarehouseAttendancePage />} />
      <Route path="stock" element={<WarehouseStockPage />} />
      <Route path="dispatches" element={<WarehouseDispatchListPage />} />
      <Route path="dispatches/:ref" element={<WarehouseDispatchEditorPage />} />
    </Route>
  </Route>
)
